
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post70() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Alguém pra indicar um adoçante que seja melhor pra quem tem diabetes?</title>
        <meta 
          name="description" 
          content="Alguém pra indicar um adoçante que seja melhor pra quem tem diabetes?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Gabrielli Machado &#183; 11/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Alguém pra indicar um adoçante que seja melhor pra quem tem diabetes?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/70')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  2 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi Gabrielli,<br/><br/>Eu entendo que escolher o adoçante certo é importante para quem tem diabetes. Muitos adoçantes são considerados seguros, mas é sempre bom conversar com o seu médico para ver qual é o melhor para o seu caso específico.<br/><br/>Algumas opções que geralmente são recomendadas são:<br/><br/>1. **Stevia** - É um adoçante natural, derivado de uma planta, e não aumenta o nível de açúcar no sangue.<br/>2. **Sucralose** - É bastante usado e não tem calorias.<br/>3. **Eritritol** - Um adoçante natural que geralmente não causa problemas digestivos.<br/><br/>Lembre-se de sempre verificar os rótulos e evitar adoçantes que contenham açúcares escondidos, como maltodextrina. E, claro, faça qualquer mudança com a orientação de um profissional de saúde.<br/><br/>Espero que isso ajude! Se tiver mais dúvidas, estou aqui para ajudar.<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 11/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/70')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Walter Medeiros &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/106-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, bom dia. Estou tomando Corus, Clorana, Carnavediol (2x ao dia) e minha pressão está 15x10. Que posso fazer?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/106')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/9-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Sobre perda e controle do peso  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Controlar meu peso foi a primeira coisa onde foquei depois do meu diagnóstico com colesterol alto. Eu estava com obesidade, e precisava reduzir meu peso de maneira sustentável e saudável. Com isso em mente, estudei e apliquei o que aprendi. <br/><br/>Algumas coisas que não sabia, mas que me aproximaram da realidade, são que pessoas que estão acima do seu peso ideal tem:<br/><br/>1) Maior risco de tornarem-se diabéticos.<br/>2) Maior risco de tornarem-se hipertensos.<br/>3) Maior risco de câncer de mama.<br/>4) Maior risco de câncer de cólon.<br/>5) Existe uma correlação direta entre sobrepeso e doenças cardíacas.<br/><br/>Com conhecimento sobre esses pontos comecei a trabalhar em desenvolver uma alimentação que me permitisse perder peso, e sustentar meu novo peso saudável. Notem aqui algo super importante, que nem sempre é evidente: a sua dieta para perda de peso precisa ser a sua nova rotina de alimentação como um todo, e não algo que você vai fazer algumas semanas enquanto perde peso, e depois vai parar e voltar para o que era antes. Se isso acontecer, todo o peso que você perdeu vai voltar em pouco tempo e com alguns kilos a mais.<br/><br/>PONTO CHAVE: A dieta de perda de peso precisa se tornar a nova rotina de alimentação como um todo.<br/><br/>Então, o ponto chave é: sua alimentação para perda de peso precisa ser sua alimentação para sustentar aquele peso. Ou seja, precisa ser sua nova educação alimentar, seu novo e permanente estilo de vida para alimentação.<br/><br/>Para montar seu novo estilo de vida alimentar é legal ter a ajuda de um nutricionista que te conhece. Mas alguns pontos gerais que eu usei e podem ser úteis:<br/><br/>O número de calorias que você consome menos o número de calorias que você queima determina se você irá ganhar ou perder peso. É importante focar em comidas que irão te dar a sensação de estar cheio/satisfeito com o menor número de calorias: comidas ricas em fibra, frutas e vegetais são ótimas opções, e devem fazer parte integral da nova alimentação (foque em no mínimo 3 frutas por dia!).<br/><br/>Corte os lanches durante o dia e a sobremesa enquanto você estiver tentando perder peso. E após ter chegado no seu peso ideal, esses lanches devem ser frutas.<br/><br/>Cuidado com o tamanho das porções. Mas coma quantos vegetais e frutas quiser, esses são livres!<br/><br/>Evite frituras. Elas adicionam cerca de um terço a mais de calorias. Prefira grelhados ou assados.<br/><br/>Faça exercícios: suas chances de perder peso e manter o peso ideal são muito melhores se você se exercitar. Até mesmo uma caminhada algumas vezes por dia é 1000 vezes melhor do que ficar sentado na frente da TV.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/9')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    J. Sandel &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/24-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Dúvida Pré-diabetes  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa noite pessoal. Tenho uma dúvida:<br/><br/>Pré-diabético toma medicamentos pra diabetes ou só faz dieta?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/24')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/6-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Cuidando do colesterol alto  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Tenho colesterol alto faz alguns anos, e quando fui diagnosticado pela primeira vez foi um pouco de choque, mas aprendi a lidar com doença e hoje meu colesterol está em níveis normais devido às mudanças que fiz de estilo de vida.<br/><br/>No fim, tenho certeza que o diagnóstico veio para o bem, pelo seguinte motivo: nos meus estudos aprendi que cerca de 85% das pessoas com mais de 50 anos (como é meu caso agora) tem algum bloqueio significativo em suas artérias, porém sem nenhum sintoma. Em dois terços dos casos (30% das vezes) o primeiro sintoma é um ataque do coração. Eu poderia estar nessa estatística, mas não estou, porque fui diagnosticado antes e mudei meu estilo de vida!<br/><br/>Duas dicas que acho que são importantes para quem descobriu que tem essa doença ou que está preocupado com seu colesterol:<br/><br/>1 - Saiba a diferença entre colesterol HDL (colesterol bom) e LDL (colesterol ruim), e como fazer para aumentar o colesterol bom e diminuir o ruim,.<br/><br/>2 - Tem 3 coisas que temos controle, e que afetam nosso colesterol e nossa saúde: nosso peso, o que comemos e nossa prática de exercícios físicos. Essas coisas estão no nosso controle e são nossa responsabilidade.<br/><br/>Esses pontos foram os que fizeram a diferença na minha saúde, e talvez possam fazer também na sua!<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/6')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        Nenhum comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Fernanda Salles &#183; 23/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/149-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde, pessoal!<br/>O que fazer pra aumentar as plaquetas?<br/>A minha irmã está em tratamento paliativo faz mais de um ano, e não está conseguindo aumentar as plaquetas de jeito nenhum, e ela precisa disso para poder tomar os remédios da quimioterapia.<br/>Ela já recebeu transfusão de sangue, está tomando ferro há quatro dias, comendo feijão, beterraba e bebendo água de coco, mas sem resultados.<br/>Alguma ideia?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/149')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
